if (!window.goshop) window.goshop = {}
if (!frappe.boot) frappe.boot = {}
